// extracted by mini-css-extract-plugin
export default {"root":"Logo__root--158cg"};